module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="background-widgets-container"></div>\n<div class="scene-widgets-container"></div>\n<div class="overlay-widgets-container"></div>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/editor/SceneWidgetCollectionViewsLayout.tpl
// module id = 3012
// module chunks = 0